import { render, staticRenderFns } from "./shopHead.vue?vue&type=template&id=43f4ef2a&scoped=true&"
import script from "./shopHead.vue?vue&type=script&lang=js&"
export * from "./shopHead.vue?vue&type=script&lang=js&"
import style0 from "./shopHead.vue?vue&type=style&index=0&lang=less&"
import style1 from "./shopHead.vue?vue&type=style&index=1&id=43f4ef2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f4ef2a",
  null
  
)

export default component.exports